// extracted by mini-css-extract-plugin
export var imageContainer = "pageBooom-module--imageContainer--ZrMeI";
export var image = "pageBooom-module--image--Pljfv";
export var iconPc = "pageBooom-module--iconPc--X1f2h";
export var iconBoom = "pageBooom-module--iconBoom--uC9Id";
export var iconLogo = "pageBooom-module--iconLogo--cmlsy";